module.exports = __webpack_public_path__ + "media/images/pic/contact-b2c19f929845df24cae88d3d4069c06b.svg";